<template>
  <div class="card">
    <div class="main-card-body">
      <div class="main-body__css">
        <div class="recruit card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Tuyển dụng:</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col lg="3" md="6">
                  <div class="card-body__block total-number-new-applicants">
                    <p class="count mb-4">
                      31
                    </p>
                    <p class="title">
                      Tổng số người <br/>nộp đơn mới
                    </p>
                    <div class="icon">
                      <i class="isax-bold-people"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block interview-candidate">
                    <p class="count mb-4">
                      10
                    </p>
                    <p class="title">
                      Ứng viên <br/> phỏng vấn
                    </p>
                    <div class="icon">
                      <i class="isax-bold-tag-user"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block successful-candidate">
                    <p class="count mb-4">
                      07
                    </p>
                    <p class="title">
                      Ứng viên <br/>trúng tuyển
                    </p>
                    <div class="icon">
                      <i class="isax-bold-profile-tick"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block reject-applicants">
                    <p class="count mb-4">
                      03
                    </p>
                    <p class="title">
                      Từ chối <br/>ứng viên
                    </p>
                    <div class="icon">
                      <i class="isax-bold-profile-delete"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>
        <div class="dictionary-contract card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Hợp đồng điện tử:</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col md="3" sm="6">
                  <div class="card-body__block total-number-of-contracts" @click="goToPage('total-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.totalContract >= 10 ?
                          electronicContract.totalContract :
                          "0" + electronicContract.totalContract
                      }}
                    </p>
                    <p class="title">
                      Tổng số <br/>hợp đồng
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-text-1"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block contract-in-progress" @click="goToPage('progress-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.progressContract >= 10 ?
                          electronicContract.progressContract :
                          "0" + electronicContract.progressContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>đang thực hiện
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-copy"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block contract-to-be-approved" @click="goToPage('approval-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.approvedContract >= 10 ?
                          electronicContract.approvedContract :
                          "0" + electronicContract.approvedContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>cần phê duyệt
                    </p>
                    <div class="icon">
                      <i class="isax-bold-edit-2"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block contract-about-to-expire">
                    <p class="count mb-4">
                      {{
                        electronicContract.expireContract >= 10 ?
                          electronicContract.expireContract :
                          "0" + electronicContract.expireContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>sắp hết hạn
                    </p>
                    <div class="icon">
                      <i class="isax-bold-note-favorite"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="10">
            <div class="vacancies-needed card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Các vị trí cần tuyển dụng</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartVacanciesNeeded"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="14">
            <div class="candidate-details card chart-card">
              <el-card>
                <div slot="header" class="card-header__css">
                  <p class="card-header__title">Chi tiết ứng viên</p>
                  <el-select v-model="model" placeholder="">
                    <el-option
                      v-for="item in statusCandidate"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="card-body-md-12">
                  <el-table
                    :data="listCandidates"
                    height="385"
                    :cell-class-name="customCellClass"
                  >
                    <el-table-column
                      prop="name"
                      label="Tên ứng viên"
                      min-width="150"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="email"
                      label="Email"
                      align="center"
                      width="210"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="nominee"
                      label="Vị trí ứng tuyển"
                      width="140"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="status"
                      label="Trạng thái"
                      align="center"
                      width="130"
                    >
                      <template slot-scope="scoped">
                        <el-tag
                          v-if="scoped.row.status"
                          :class="{
                            'under-review': scoped.row.status === 'under-review',
                            'successful': scoped.row.status === 'successful',
                            'reject': scoped.row.status === 'reject'
                          }"
                        >
                          {{
                            scoped.row.status == 'under-review' ? 'Đang xét duyệt' :
                            scoped.row.status == 'successful' ? 'Trúng tuyển' :
                            scoped.row.status == 'reject' ? 'Bị loại' : 'Đang xét duyệt'
                          }}
                        </el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="10">
            <div class="vacancies-needed card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Kênh tuyển dụng</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartRecruitmentChannel"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="14">
            <div class="candidate-details card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Chi tiết ứng viên</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :heightChart="'400'"
                    :optionChart="optionChartApplicationReceptionDepartment"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import EChart from '../../../../component/EChart/EChart';
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi';
export default {
  components: {
    EChart,
  },
  data() {
    return {
      optionChartVacanciesNeeded: {},
      optionChartRecruitmentChannel: {},
      optionChartApplicationReceptionDepartment: {},
      listCandidates: [],
      electronicContract: {
        totalContract: 0,
        progressContract: 0,
        approvedContract: 0,
        expireContract: 0
      },
      statusCandidate: [
        {
          value: 'all',
          label: 'Tất cả',
        },
        {
          value: 'under-review',
          label: 'Đang xét duyệt',
        },
        {
          value: 'successful',
          label: 'Trúng tuyển',
        },
        {
          value: 'reject',
          label: 'Bị loại',
        },
      ],
      model: 'all',
    }
  },
  methods: {
    goToPage(type) {
      if (!type) return
      if (type == 'total-contract') this.routerPush('Admin-DocumentDrafting-list')
      if (type == 'progress-contract') this.routerPush('Admin-DocumentDrafting-list', {status: 'DangThucHien'})
      if (type == 'approval-contract') this.routerPush('Admin-DocumentDrafting-list', {status: 'ChoKy'})
    },
    routerPush(name, query) {
      if (query) {
        this.$router.push({ name: name, query: query }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      } else {
        this.$router.push({ name: name }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    customCellClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'name-candidate';
      }
      if (columnIndex === 1) {
        return 'email-candidate';
      }
      if (columnIndex === 2) {
        return 'positon-candidate';
      }
      if (columnIndex === 3) {
        return 'status-candidate';
      }
    },
    async getDataBlockContract() {
      Promise.all([
        DraffDocumentAutoApi.list({
          limit: 1
        }),
        DraffDocumentAutoApi.list({
          filters: 'status:in:DRAFF,GENERATING,COMPLETED,FAILED',
          limit: 1
        }),
        DraffDocumentAutoApi.list({
          filters: 'status:in:SIGN_WAITING',
          limit: 1
        }),
      ]).then(res => {
        if (res.length > 0) {
          this.electronicContract = {
            totalContract: res[0].meta.total,
            progressContract: res[1].meta.total,
            approvedContract: res[2].meta.total,
            expireContract: 0
          }
        }
      })
    },
    getVacanciesNeeded() {
      this.optionChartVacanciesNeeded = {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: `
        //     Các vị trí cần tuyển dụng <br/>
        //     {b} : {c} bài
        //   `,
        //   textStyle: {
        //     fontSize: 16,
        //     fontFamily: 'UTM Avo',
        //     fontWeight: 400,
        //   }
        // },
        legend: {
          left: 'center',
          icon: 'circle',
          itemGap: 18,
          itemWidth: 20,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            name: 'Traffic Sources',
            type: 'pie',
            radius: '70%',
            color: ['#FFA600', '#56CCF2', '#FF5A5A', '#30DA88', '#6600FF', '#5787A4'],
            top: '10%',
            label: {
              fontSize: 15,
              fontWeight: 'bold',
              fontFamily: 'UTM Avo',
              formatter: `{c} bài`
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            data: [
              { value: 5, name: 'Marketing' },
              { value: 2, name: 'IT' },
              { value: 4, name: 'Kinh doanh' },
              { value: 12, name: 'Kế toán' },
              { value: 7, name: 'Kỹ thuật' },
              { value: 5, name: 'Pháp chế' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    getListCandidates() {
      this.listCandidates = [];
      let status = ['under-review', 'successful', 'reject'];
      let nominees = ['Marketing', 'IT', 'Kinh doanh', 'Kế toán', 'Kỹ thuật', 'Pháp chế'];
      for (let index = 0; index < 15; index++) {
        this.listCandidates.push({
          name: 'Nguyễn Văn Anh',
          email: 'thanhnemo@gmail.com',
          nominee: nominees[Math.floor(Math.random() * nominees.length)],
          status: status[Math.floor(Math.random() * 3)],
        })
      }
    },
    getRecruitmentChannel() {
      this.optionChartRecruitmentChannel = {
        legend: {
          left: 'center',
          icon: 'circle',
          itemGap: 20,
          itemWidth: 20,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        grid: {
          top: '16%',
          left: '1%',
          right: '1%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: ['Kênh tuyển dụng'],
          axisLabel: {
            rotate: 90
          },
          show: false,
        },
        series: [
          {
            name: 'Website tuyển dụng',
            type: 'bar',
            data: [22],
            barWidth: '15%',
            barGap: '70%',
            color: '#FFA600',
            label: {
              show: true,
              position: 'right',
              fontSize: 16,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
            },
            itemStyle: {
              emphasis: {
                barBorderRadius: [50, 50]
              },
              normal: {
                barBorderRadius: [0, 5, 5 ,0]
              }
            }
          },
          {
            name: 'Mạng xã hội',
            type: 'bar',
            data: [30],
            barWidth: '15%',
            color: '#6600FF',
            label: {
              show: true,
              position: 'right',
              fontSize: 16,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
            },
            itemStyle: {
              emphasis: {
                barBorderRadius: [50, 50]
              },
              normal: {
                barBorderRadius: [0, 5, 5 ,0]
              }
            }
          },
          {
            name: 'Kết nối đơn vị đào tạo',
            type: 'bar',
            data: [31],
            barWidth: '15%',
            color: '#56CCF2',
            label: {
              show: true,
              position: 'right',
              fontSize: 16,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
            },
            itemStyle: {
              emphasis: {
                barBorderRadius: [50, 50]
              },
              normal: {
                barBorderRadius: [0, 5, 5 ,0]
              }
            }
          },
          {
            name: 'Giới thiệu',
            type: 'bar',
            data: [27],
            barWidth: '15%',
            color: '#FF5A5A',
            label: {
              show: true,
              position: 'right',
              fontSize: 16,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
            },
            itemStyle: {
              emphasis: {
                barBorderRadius: [50, 50]
              },
              normal: {
                barBorderRadius: [0, 5, 5 ,0]
              }
            }
          }
        ]
      }
    },
    getApplicationReceptionDepartment() {
      this.optionChartApplicationReceptionDepartment = {
        grid: {
          left: '1%',
          right: '1%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['Marketing', 'IT', 'Kinh doanh', 'Kế toán', 'Kỹ thuật', 'Pháp chế'],
          axisLabel: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 'bold',
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              fontSize: 16,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
            },
            data: [
              {
                value: 5,
                barWidth: '15%',
                itemStyle: {
                  color: '#FFA600',
                }
              },
              {
                value: 10,
                barWidth: '15%',
                itemStyle: {
                  color: '#56CCF2'
                }
              },
              {
                value: 15,
                barWidth: '15%',
                itemStyle: {
                  color: '#FF5A5A'
                }
              },
              {
                value: 2,
                barWidth: '15%',
                itemStyle: {
                  color: '#30DA88'
                }
              },
              {
                value: 21,
                barWidth: '15%',
                itemStyle: {
                  color: '#6600FF'
                }
              },
              {
                value: 4,
                barWidth: '15%',
                itemStyle: {
                  color: '#5787A4'
                }
              },
            ],
          }
        ]
      }
    }
  },
  created() {
    this.getDataBlockContract()
    this.getVacanciesNeeded()
    this.getListCandidates()
    this.getRecruitmentChannel()
    this.getApplicationReceptionDepartment()
  },
}
</script>
<style lang="scss" scoped>
.main-body__css{
  .card-md-12 {
    margin-bottom: 14px;
  }
}
::v-deep .el-card {
  .el-card__header{
    padding: 15px 15px 10px 15px;
    .card-header__css {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select  {
        max-width: 150px;
        .el-input__inner {
          height: 33px !important;
        }
      }
    }
    .card-header__title{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
      color: #000000;
    }
  }
  .el-card__body{
    padding: 0 10px 15px 10px;
  }
}

::v-deep .card-body-md-12{
  [class^="col-"], [class*=" col-"] {
    padding-right: 5px;
    padding-left: 5px;
  }
  .card-body__block{
    position: relative;
    height: 120px;
    border-radius: 10px;
    color: #FFFFFF;
    padding: 17px 23px;
    &:hover {
      cursor: pointer;
    }
    .count {
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 26px;
      line-height: 28px;
      color: #FFFFFF;
    }
    .title {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #FFFFFF;
      width: 120px;
    }
    .icon {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 25px;
      [class^="isax-bold-"] {
        &::before {
          font-size: 40px;
          line-height: 40px;
        }
      }
    }
    &.total-number-new-applicants{
      background: #FF993A;
    }
    &.interview-candidate{
      background: #34AA4A;
    }
    &.successful-candidate{
      background: #56B9F2;
    }
    &.reject-applicants{
      background: #FF5A5A;
    }
    &.total-number-of-contracts{
      background: #0AB8B6;
    }
    &.contract-in-progress{
      background: #4690CD;
    }
    &.contract-to-be-approved{
      background: #3753A6;
    }
    &.contract-about-to-expire{
      background: #5A51A2;
    }
  }
}
::v-deep .candidate-details {
  .el-table {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    thead {
      tr {
        th {
          background-color: #fff !important;
          color: #606060;
          font-weight: 700;
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
    .name-candidate {
      .cell {
        font-family: 'Roboto';
        font-weight: 600;
        font-size: 13px;
        line-height: 24px;
        padding-left: 15px;
      }
    }
    .el-tag {
      min-width: 110px;
      font-family: 'Roboto';
      font-weight: 400;
      font-size: 12px;
      border-radius: 4px;
      &.under-review {
        background: #FFA600;
        border-color: #FFA600;
        color: #fff;
      }
      &.successful {
        background: #30DA88;
        border-color: #30DA88;
        color: #fff;
      }
      &.reject {
        background: #FF5A5A;
        border-color: #FF5A5A;
        color: #fff;
      }
    }
  }
}
</style>
